module.exports = __webpack_public_path__ + "img/21.ba50d803.png";